export default __webpack_public_path__ + "static/media/ic-pin-white.10e93b29.svg";